module.exports = __webpack_public_path__ + "static/img/1043.9a9e92d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1043.jpg
// module id = 225
// module chunks = 0